import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import {Menu, AsyncTypeahead} from 'react-bootstrap-typeahead';
import Help from '../../../generics/help';
import {MenuItem} from 'react-bootstrap';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var Config = require('../../../../config');

class Debts extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.setTableTrans = this.setTableTrans.bind(this);
		this.setTableDon = this.setTableDon.bind(this);
		this.checking = this.checking.bind(this);
		this.updateState = this.updateState.bind(this);
		this.changeStyle = this.changeStyle.bind(this);
		this.excelStats = this.excelStats.bind(this);
		this.pdfStats = this.pdfStats.bind(this);

		this.state = {
			start_date:"",
			end_date:"",
			filename:'Balance de pacientes',
			listadoTrans:[],
			listadoDon:[],
			columns_trans:[
				{title: 'FECHA TRANSFUSIÓN'},
				{title: 'HORA DE ENVÍO'},	
				{title: 'UNIDAD'},
				{title: 'No. COMPONENTE'},
				{title: 'COMPONENTE'},
				{title: 'GPO & RH'},
				{title: 'VOLUMEN'}
			],
			columns_don:[
				{title:'FECHA DONACIÓN'},
				{title:'LUGAR DE COLECTA'},
				{title:'DONANTE'},
				{title:'ESTATUS'},
				{title:'TIPO DONACIÓN'},
				{title:'TIPO EXTRACCIÓN'},
				{title:'GPO. & RH'},
				{title:'LABORATORIO'},
				{title:'COMPONENTE'},
				{title:'DONACIÓN'}
			],
			date_hour:"",
			medical:"",
			options:[],
			patient:"",
			patient_g_rh:"",
			change_check: false,
			isLoading:false,
			patient_name:"",
			transfusion:[],
			offers:[],
			units_delivered:"0",
			apto:"0",
			no_apto:"0",
			total:"0",
			tot_st:"0",
			tot_af:"0",
			tot_afe:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			/*this.setState({
				date_hour:aux[0]+' '+hours,
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
			});*/
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		document.getElementById('start_date').focus();
		try {
			
			this.setTableTrans();
		} catch (error) {
			
		}
		this.setTableDon();
		
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});			
	}

	setTableTrans(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el_t = $(this.el_trans);
		
		var table = this.$el_t.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	text: 'Excel',
                	action: () => {
                		this.excelStats();
                	}
            	},
            	{
                	extend: 'pdfHtml5',
                	title: this.state.filename,
                	orientation: 'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});

                		doc.content.splice(2, 0, {text: fechas+'\t\t'+this.state.patient_name, margin:[10,0,0,10] });

                		doc.content.push({text: 'Unidades Enviadas: '+this.state.units_delivered, margin:[10,10,0,10], bold:1})
                		
                		if (this.state.components && this.state.components.length > 0) {
                			var componentsText = '';
                			this.state.components.forEach((comp) => {
                				componentsText += comp.component_type.replace(/_/g, ' ') + ': ' + comp.total + '\t';
                			});
                			doc.content.push({
                				text: componentsText, 
                				margin: [10, 5, 0, 10], 
                				fontSize: 9
                			});
                		}
                		
                		doc.content[3].table.widths=["15%", "15%", "10%", "10%", "25%", "10%", "15%"];
                		var tbl = [];
                		var titles = [];
                		this.state.columns_don.map((t)=>{
                			titles.push(
                				{text:t.title, style:"tableHeader", fillColor:"#2d4154"}
                			)
                		})
                		tbl.push(titles);
                		this.state.listadoDon.map((l)=>{
                			var obj = [];
                			l.map((t)=>{
                				obj.push({text:t})
                			})
                		
                			tbl.push(obj);
                		})

                		doc.content.push({
                			table:{
                				body:tbl
                			},
                			layout:"noBorders"
                		})
                		
                		var donTableIndex = doc.content.length - 1;
                		doc.content[donTableIndex].table.widths=["10%","10%","15%","5%", "10%","10%","10%","10%","10%","10%"];
                		
                		doc.content.push({
                			text: 'Aptos: '+this.state.apto+
                				  '\t\tNo Aptos: '+this.state.no_apto+
                				  '\t\tTotal: '+this.state.total, margin:[10,10,0,10], bold:1});
                		
                		var extractionText = 'Sangre Total: ' + this.state.tot_st + '\t\tAféresis: ' + this.state.tot_af;
                		if (this.state.tot_afe && Object.keys(this.state.tot_afe).length > 0) {
                			Object.keys(this.state.tot_afe).forEach((kit) => {
                				extractionText += '\t\t' + kit + ': ' + this.state.tot_afe[kit];
                			});
                		}
                		doc.content.push({
                			text: extractionText, 
                			margin: [10, 5, 0, 10], 
                			bold: 1
                		});

						doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
			data: this.state.listadoTrans,
			columns:this.state.columns_trans,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"16em",
			scrollX: true,
			autoWidth: false,
			info:false,
			ordering:false,
			createdRow: (row, data, dataIndex)=>{
				
				
			}	
			
		});

		setTimeout(()=>{
			if (this.state.listadoTrans.length === 0 && this.state.listadoDon.length === 0){// table.rows().indexes().length === 0 ) {
				table.buttons('.buttons-html5').disable();
			}else {
				table.buttons('.buttons-html5').enable();
			}
		}, 500)
		
	}

	setTableDon(){
		this.$el_d = $(this.el_don);
		
		var table = this.$el_d.DataTable({
			data: this.state.listadoDon,
			columns:this.state.columns_don,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"16em",
			scrollX: true,
			autoWidth: false,
			info:false,
			ordering:false,
			createdRow: (row, data, dataIndex)=>{
				if(data[2] === 'NO APTO'){
					$(row).attr('class', 'danger');
				}
			}	
			
		});

	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					patient_id: this.state.patient,
					start_date: !this.state.change_check ? this.state.start_date : null,
					end_date: !this.state.change_check ? this.state.end_date : null,
					health_facilities_id:sessionStorage.getItem('health_facilities_id')
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/patient_debt',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listadoTrans: [],
							listadoDon:[],
							totals:[],
							components:[],
						});
						var list_t = [], list_d = [];
						response.offers.map((u)=>{

							var component = ""
							u.components.map((c, i) => {
								component += c+(i === u.components.length - 1 ? '' : ', ');
							});
							list_d.push([
								moment(u.timestamp_date).format('DD/MM/YYYY'),
								u.convoke_place,
								u.donor,
								(u.status === 'ACCEPT' ? 'APTO' :
								 u.status === 'REJECT' ? 'NO APTO' : ''),
								u.donation_type,
								u.extraction_type+
								(u.extraction_type === 'AFÉRESIS' ? ' - '+u.kit : ''),
								u.g_rh,
								u.laboratory,
								component,								
								u.donation_number
							])
								
						});

						response.units_delivered.map((u)=>{
							list_t.push([
								moment(u.register_date).format('DD/MM/YYYY'),
								moment(u.register_hour, 'HH:mm:ss').format('HH:mm'),
								u.unit_number,
								u.component_number,
								u.component,
								u.g_rh,
								u.volume
							])
								
						});
						// Objeto para almacenar los recuentos de componentes por id
							// Crear un contador para los kits
    						const kitCount = {};
							// Contar ocurrencias de componentes para cada id
							response.offers.forEach(item => {
								const kit = item.kit;
								// Verificar si el kit no está vacío
								if (kit) {
									// Si el kit ya existe en el contador, incrementarlo
									if (kitCount[kit]) {
										kitCount[kit]++;
									} else {
										// Si no existe, inicializarlo a 1
										kitCount[kit] = 1;
									}
								}
							});
							// Generar los elementos JSX
    						const jsxElements = [];
							for (const kit in kitCount) {
								jsxElements.push(
									<div key={kit}>
										<label key={kit}>{kit}:</label>
										<span style={{ marginLeft: '8px' }}>{kitCount[kit]}</span>
									</div>
								);
							}
							this.setState({tot_afe:kitCount});
						response.exportUnits.map((u)=>{
							list_t.push([
								moment(u.register_date).format('DD/MM/YYYY'),
								moment(u.register_hour, 'HH:mm:ss').format('HH:mm'),
								u.unit_number,
								u.component_number,
								u.component,
								u.g_rh,
								u.volume
							])
								
						});
						//revisar
						response.totals.map((r)=>{
							if(r.extraction_type === 'SANGRE TOTAL'){
								this.setState({tot_st:r.total});
							}else if(r.extraction_type === 'AFÉRESIS'){
								this.setState({tot_af:r.total});
							}
						});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el_t = $(this.el_trans);
							this.$el_t.DataTable().destroy();
							this.$el_t.empty();

							this.$el_d = $(this.el_don);
							this.$el_d.DataTable().destroy();
							this.$el_d.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							try {
								
								this.setTableTrans();
							} catch (error) {
								
							}
							this.setTableDon();
							
						}, 1000);

						this.setState({
							listadoTrans: list_t,
							listadoDon:list_d,
							units_delivered:response.units_delivered_count,
							apto:response.aptos,
							no_apto:response.no_aptos,
							total:response.offers_count,
							totals:response.totals,
							components:response.components,
							patient_g_rh: response.patient_grh
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(document.getElementById('end_date') !== null){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}
				
		}else{
			date_ok = false;
		}		

		if(this.state.change_check){
			date_ok = true;
		}
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false
			});
		}else{
			this.setState({
				change_check: true,
				start_date:"",
				end_date:""
			});
		}
	}

	_handleSearch = (query) => {
	    this.setState({isLoading: true});

	    this.changeStyle();
		fetch(Config.default.apiGateway.URL+'person?search='+query,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
			    })
			})
			.then(response => response.json())
			.then(response => {
				for (var i = 0; i < response.length; i++) {

					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '
											+response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					}


					if(response[i].document_type_value !== null){
						response[i].names +=' '+response[i].document_type_value;
					}

					if(response[i].document_number !== null){
						response[i].names +=' '+response[i].document_number;
					}

					if(response[i].number !== null){
						response[i].names += ' '+response[i].number
					}
					
					response[i].id = response[i].patient_id;
				};
				this.setState({
					isLoading: false,
			     	options: response,
			     	units_delivered:"0",
					apto:"0",
					no_apto:"0",
					total:"0",
					tot_st:"0",
					tot_af:"0"
			    });

				this.changeStyle();
			})
	}

	updateState(values) {
	    let value = '';
	    if (values.length > 0) {
	      	value = values[0];

	      	if(value.person === undefined){

	      		fetch(Config.default.apiGateway.URL+'patients/patient_offer?id='+value.id,{
			   		method:'GET',
			   		headers: new Headers({
			   			'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
			   			'Accept'		: 'application/json',
			   			'Content-Type'	: 'application/json'
			   		})
			   	}).then(res => {
			   		if(res.ok){
			   			return res.json();
			   		}else{
			   			res.text().then((msg)=>{
			   				swal('Error', msg, 'error');
			   			});
			   		}
			   	}).then(response => {
			   		if(response !== undefined){
						this.updateState([response]);
		    			return;
			   		}
			   	})
			   }else{
			   		this.setState({
			     		patient:value.patient.id,
			     		patient_name: value.person.lastname1 +' '+ 
									(value.person.lastname2 !== undefined &&  value.person.lastname2 !== null ?
										value.person.lastname2+' ' : '')+
									value.person.names
			     	});

			     	setTimeout(()=>{
			     		this._typeahead.getInstance().blur();
			     		this.searching()
			     	}, 500);	
			   }

			     	     	

	    }
	}

	changeStyle(){
		$('.show').addClass('report_autocomplete');
	}

	excelStats() {
		var obj = {
			patient_id: this.state.patient,
			start_date: !this.state.change_check ? this.state.start_date : null,
			end_date: !this.state.change_check ? this.state.end_date : null,
			health_facilities_id: sessionStorage.getItem('health_facilities_id')
		};

		this.props.waiting.handleShow('Generando Excel...');
		fetch(Config.default.apiGateway.URL + 'reports/generate_excel?report_name=patient_debt', {
			method: 'POST',
			body: JSON.stringify(obj),
			responseType: 'blob',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if (res.ok) {
				return res.blob();
			} else {
				res.text().then(msg => {
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if (response !== undefined) {
				var blob = new Blob([response], { type: 'application/vnd.ms-excel' });
				var downloadUrl = URL.createObjectURL(blob);
				var a = document.createElement("a");
				a.href = downloadUrl;
				a.download = this.state.filename + '.xlsx';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				URL.revokeObjectURL(downloadUrl);
			}
		});
	}

	pdfStats() {
		var fechas = "Información Del: " + (this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY") : '') +
			" Al: " + (this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '')

		var doc = {
			content: [
				{
					image: this.props.header_document,
					alignment: 'center',
					width: this.props.w_head
				},
				{
					text: this.state.filename, style: 'title', margin: [0, 10, 0, 12], alignment: 'center', fontSize: 15
				},
				{
					text: fechas + '\t\t' + this.state.patient_name, margin: [10, 0, 0, 10]
				},
				{
					text: 'UNIDADES ENVIADAS', style: 'subheader', margin: [0, 10, 0, 5]
				},
				{
					layout: 'noBorders',
					table: {
						body: [],
						headerRows: 1,
						widths: ['15%', '15%', '10%', '10%', '25%', '10%', '15%']
					}
				},
				{
					text: 'DONACIONES', style: 'subheader', margin: [0, 20, 0, 5]
				},
				{
					layout: 'noBorders',
					table: {
						body: [],
						headerRows: 1,
						widths: ['10%', '10%', '15%', '5%', '10%', '10%', '10%', '10%', '10%', '10%']
					}
				}
			],
			defaultStyle: { fontSize: 8 },
			pageMargins: 40,
			footer: { text: this.state.date_hour + '\t-\t' + this.state.medical, alignment: 'right', margin: [0, 0, 50, 0] },
			pageOrientation: 'portrait',
			pageSize: 'A4',
			styles: {
				tableBodyEven: {},
				tableBodyOdd: { fillColor: '#f3f3f3' },
				tableHeader: { bold: true, fontSize: 8, color: 'white', fillColor: '#2d4154', alignment: 'center' },
				subheader: { bold: true, fontSize: 10, margin: [0, 10, 0, 5] }
			}
		};

		var transBody = [];
		var transHeaderRow = [];
		this.state.columns_trans.forEach((col) => {
			transHeaderRow.push({ text: col.title, style: 'tableHeader', fillColor: '#2d4154' });
		});
		transBody.push(transHeaderRow);

		this.state.listadoTrans.forEach((row, i) => {
			var dataRow = [];
			row.forEach((value) => {
				dataRow.push({ text: value, style: ((i + 1) % 2) === 0 ? 'tableBodyOdd' : 'tableBodyEven' });
			});
			transBody.push(dataRow);
		});

		doc.content[4].table.body = transBody;

		var donBody = [];
		var donHeaderRow = [];
		this.state.columns_don.forEach((col) => {
			donHeaderRow.push({ text: col.title, style: 'tableHeader', fillColor: '#2d4154' });
		});
		donBody.push(donHeaderRow);

		this.state.listadoDon.forEach((row, i) => {
			var dataRow = [];
			row.forEach((value) => {
				dataRow.push({ text: value, style: ((i + 1) % 2) === 0 ? 'tableBodyOdd' : 'tableBodyEven' });
			});
			donBody.push(dataRow);
		});

		doc.content[6].table.body = donBody;

		doc.content.push(
			{
				text: 'Unidades Enviadas: ' + this.state.units_delivered, margin: [10, 10, 0, 10], bold: 1
			}
		);

		if (this.state.components && this.state.components.length > 0) {
			var componentsText = '';
			this.state.components.forEach((comp) => {
				componentsText += comp.component_type.replace(/_/g, ' ') + ': ' + comp.total + '\n';
			});
			doc.content.push({
				text: componentsText, 
				margin: [10, 5, 0, 10], 
				fontSize: 9
			});
		}

		doc.content.push(
			{
				text: 'Aptos: ' + this.state.apto + '\t\tNo Aptos: ' + this.state.no_apto + '\t\tTotal: ' + this.state.total, 
				margin: [10, 10, 0, 10], bold: 1
			},
			{
				text: 'Sangre Total: ' + this.state.tot_st + '\t\tAféresis: ' + this.state.tot_af, 
				margin: [10, 10, 0, 10], bold: 1
			}
		);

		pdfMake.createPdf(doc).download(this.state.filename + '.pdf');
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{sessionStorage.getItem('health_facilities_name')} {'>'}
					{t('sidebar.nav.reports.MAIN')} {'>'}
					Paciente {'>'}
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_debts"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								
								<div className="form-group">
									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cualquier Fecha</span>
								</div>
								{!this.state.change_check &&
									<div className="form-group">
										<span className="span-min">Fecha Desde</span>
										<input type="date" className="form-control hour-input" name="start_date" id="start_date"
											value={this.state.start_date} onChange={this.handleChange} />
									</div>
								}
								{!this.state.change_check &&
									<div className="form-group">
										<span className="span-min">Fecha Hasta</span>
										<input type="date" className="form-control hour-input" name="end_date" id="end_date"
											value={this.state.end_date} onChange={this.handleChange} />
									</div>
								}
								<div className="form-group">
									<span className="span-min">Paciente</span>
							        <AsyncTypeahead
							          	labelKey={(option) => `${option.names}`}
							          	minLength={5}
							          	name="patient_id"
							          	id="patient_id"
							          	inputProps={{
							          		name:"patient",
							          		required: true,
							          		id:"patient",
							          		autoComplete:"off",
							          	}}
							          	onSearch={this._handleSearch}
							          	placeholder="Buscar por apellidos más nombre o número de documento..."
							          	options={this.state.options}
							          	onChange={this.updateState}
							          	ref={ref => this._typeahead = ref}
							          	useCache={false}
							          	isLoading={this.state.isLoading}
							          	selectHintOnEnter={true}
							          	onMenuToggle={this.changeStyle}
							          	onKeyDown={this.changeStyle}
							          	onFocus={this.changeStyle}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>
								<div className="col-xs-12 form-group">
									<h4 style={{display:'inline-blocky'}}>{this.state.patient_name} <span style={{color:'red', display:'inline-block'}}>{this.state.patient_g_rh}</span></h4>
									
									{/* {(this.state.listadoTrans.length > 0 || this.state.listadoDon.length > 0) &&
										<div style={{textAlign:'right', marginBottom:'15px', clear:'both'}}> 
											<button className="dt-button buttons-excel buttons-html5" tabIndex="0" aria-controls="table-to-trans" type="button" onClick={()=>this.excelStats()}>
												<span>Excel</span>
											</button> 
											<button className="dt-button buttons-pdf buttons-html5" tabIndex="0" aria-controls="table-to-trans" type="button" onClick={()=>this.pdfStats()}>
												<span>PDF</span>
											</button> 
										</div>
									} */}
									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}}  id="table-to-trans" width="100%" ref={el_t => this.el_trans = el_t}>
										</table>

									</div>
									<div style={{ marginTop: '8px' }}>
										<label>Unidades Enviadas</label><span style={{ marginLeft: '8px' }}>{this.state.units_delivered}</span>
										<div style={{ marginTop: '8px' }}>
											{this.state.components && this.state.components.length > 0 ? (
												this.state.components.map((comp, index) => (
													<React.Fragment key={index}>
														<label style={{ marginLeft: index === 0 ? '0' : '10px' }}>
															{comp.component_type.replace(/_/g, ' ')}:
														</label>
														<span style={{ marginLeft: '8px' }}>{comp.total}</span>
													</React.Fragment>
												))
											) : (
												<p>Sin componentes.</p>
											)}
										</div>
									</div>
								</div>
								<div className="col-xs-12 form-group">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}}  id="table-to_don" width="100%" ref={el_d => this.el_don = el_d}>
										</table>
										
									</div>
									<div style={{marginTop:'8px'}}>
										<label>Aptos: </label><span style={{marginLeft:'8px'}}>{this.state.apto}</span>
										<label style={{marginLeft:'10px'}}>No Aptos: </label><span style={{marginLeft:'8px'}}>{this.state.no_apto}</span>
										<label style={{marginLeft:'10px'}}>Total: </label><span style={{marginLeft:'8px'}}>{this.state.total}</span>
									</div>
									<div style={{marginTop:'8px'}}>
										<label>Sangre Total:</label><span style={{marginLeft:'8px'}}>{this.state.tot_st}</span>
										<label style={{marginLeft:'10px'}}>Aféresis:</label><span style={{marginLeft:'8px'}}>{this.state.tot_af}</span>
										{Object.keys(this.state.tot_afe).length > 0 ? (
										Object.keys(this.state.tot_afe).map((kit,i) => (
											
												<><label key={kit} style={{marginLeft:'10px'}}>{kit}:</label><span key={kit+i} style={{ marginLeft: '10px' }}>{this.state.tot_afe[kit]}</span></>
											
										))
									) : (
										<p>.</p>
									)}
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}
export default translate('translations')(Debts)